<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>KRI Registry</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight px-0">
    <!-- FILTER -->
    <div class="ibox-content mb-1 px-3 py-2">
      <div class="form-group row my-0 d-flex align-items-end">
        <div class="col-12 col-lg-3 px-1">
          <label class="mb-0">KRI ID</label>
          <input type="text" v-model="searchField.kriId" class="form-control" placeholder="KRI ID"
            @keyup.enter="searchReports" />
        </div>

        <div class="col-12 col-lg-3 px-1">
          <label class="mb-0">CTQ ID</label>
          <input type="text" v-model="searchField.ctqId" class="form-control" placeholder="CTQ ID"
            @keyup.enter="searchReports" />
        </div>

        <div class="col-12 col-lg-5 px-1">
          <label class="mb-0">Risk ID</label>
          <input type="text" v-model="searchField.riskId" class="form-control" placeholder="Risk ID"
            @keyup.enter="searchReports" />
        </div>

        <div class="col-12 col-lg-1 px-1">
          <span class="save_btn w-100 d-inline-block text-center" @click="searchReports">
            Search
          </span>
        </div>
      </div>
    </div>

    <!-- TABLE -->
    <div class="ibox-body">
      <div class="ibox-title style_2 d-flex align-items-center justify-content-between">
        <h5 class="mt-0">{{ $t("navigations.keyRiskIndicators") }}</h5>
        <div v-if="rollsprivilages.includes('KRI Registry Add')" class="position-relative align-self-center">
          <img
            src="@/assets/img/create.png"
            width="17"
            alt="Add Arm"
            style="cursor: pointer"
            @click="openManageKRIModal()"
          />
          <div class="tool-tip">{{ $t("navigations.addkri") }}</div>
        </div>
      </div>

      <div class="ibox-content p-1">
        <!-- LOADER -->
        <div class="text-center" v-if="loading">
          <img src="../../assets/img/loading.gif" width="15" />
          <div>Please wait while the list is being loaded</div>
        </div>

        <!-- NO DATA -->
        <div class="text-center" v-else-if="!kriList.length">
          No data available
        </div>

        <div v-else>
          <div class="table-responsive" style="overflow-x: auto;">
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>KRI ID</th>
                  <th>CTQ ID</th>
                  <th>Risk ID</th>
                  <th>Risk Indicator</th>
                  <th v-if="rollsprivilages.includes('KRI Registry Edit')" class="text-center">Edit</th>
                  <th class="text-center">View</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in kriList" :key="item.id">
                  <td>
                    <span>{{ item.kriId }}</span>
                  </td>
                  <td>{{ item.ctqId }}</td>
                  <td>{{ item.riskId }}</td>
                  <td class="description-cell">
                    <div>
                      <span>{{
                        item.expanded
                          ? item.riskIndicator
                          : truncate(item.riskIndicator)
                      }}</span>
                      <a
                        v-if="
                          item.riskIndicator &&
                          item.riskIndicator.length > 120
                        "
                        class="more-less-link ms-1"
                        @click.stop="toggleExpand(item)"
                      >
                        {{ item.expanded ? "less" : "more" }}
                      </a>
                    </div>
                  </td>
                  <td v-if="rollsprivilages.includes('KRI Registry Edit')" class="text-center">
                    <i
                      class="fa fa-edit edit-delete"
                      title="Edit KRI"
                      @click="openManageKRIModal(item)"
                    >
                    </i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye edit-delete"
                      title="View KRI"
                      @click="viewKriDetails(item)"
                    >
                    </i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="row mx-0 mt-3" v-if="totalPages > 1">
            <div class="col-12 d-flex justify-content-end">
              <VPagination
                v-model="currentPage"
                :pages="totalPages"
                :range-size="1"
                active-color="#618bd7"
                @update:modelValue="loadPage"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <KriDetailsModal
    v-if="showKriDetailsModal"
    :data="selectedKriItem"
    @closeModal="closeKriDetailsModal"
  />

  <manageKRIModal
    v-if="openCreateRiskModal"
    :riskEditData="riskEditData"
    fromPage="kriRegistry"
    @closeModal="closeKRIRiskModal"
    @reloadList="reloaddatagrid"
  />
</template>
<script src="./KriRegistry.js"></script>

<style scoped>
.ibox-title {
    padding: 2px 15px 8px 15px;
    min-height: 36px;
}
.sort_block {
  cursor: pointer;
}
.description-cell {
    max-width: 280px;
    white-space: normal;
    word-break: break-word;
}
.more-less-link {
    color: #618bd7 !important;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 600;
    white-space: nowrap;
    user-select: none;
    text-decoration: none;
}
.more-less-link:hover {
    text-decoration: underline !important;
}
.position-relative .tool-tip {
    right: 18px;
    top: 0px;
}
</style>    